module.exports = __webpack_public_path__ + "static/media/B-NAZANIN.fe70eb00.TTF";